import { render, staticRenderFns } from "./Saml.vue?vue&type=template&id=76a68ce4&scoped=true"
import script from "./Saml.vue?vue&type=script&lang=js"
export * from "./Saml.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76a68ce4",
  null
  
)

export default component.exports